import { Box, CTALink, Heading, Stack } from '@99designs/emu';
import { DesignInspiration } from '@99designs/feature-design-inspiration';
import { formatMessage } from '@99designs/frontend-components/i18n';
import { GridLayout } from '@99designs/marketing-ui';
import { Desktop, Mobile } from '@99designs/spa-common';
import type { Design } from '@99designs/feature-design-inspiration';

type Props = {
    designOutcome: string;
    categoryKeys: string[];
    designs: Design[];
};

export function Inspiration({ designOutcome, categoryKeys, designs }: Props) {
    const categoryKeysParams = categoryKeys.join(',');

    return (
        <Stack space={['0.5bu', '0.5bu', '1bu', '1bu']}>
            <GridLayout>
                <Box display="flex" justifyContent="space-between" flexWrap="wrap">
                    <Box paddingRight="1bu" paddingBottom={['none', 'none', '0.5bu', '0.5bu']}>
                        <Heading appearanceLevel={3} accessibilityLevel={2}>
                            {formatMessage(__('{designOutcome} created on 99designs'), {
                                designOutcome,
                            })}
                        </Heading>
                    </Box>
                    <Desktop>
                        <CTALink href={`/discover?category=${categoryKeysParams}`}>
                            {__('See more inspiration')}
                        </CTALink>
                    </Desktop>
                </Box>
            </GridLayout>
            <DesignInspiration
                categoryKeys={categoryKeys}
                designs={designs}
                showSeeMoreLink={false}
            />
            <GridLayout>
                <Mobile>
                    <CTALink href={`/discover?category=${categoryKeysParams}`}>
                        {__('See more inspiration')}
                    </CTALink>
                </Mobile>
            </GridLayout>
        </Stack>
    );
}
